import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDownRight } from "lucide-react";
import { EASE, Chapter } from "@/components/Reveal";
import { scrollToHash } from "@/components/Navbar";

const LINES = ["L'ingénierie", "financière des dossiers", "à fort enjeu."];

export default function Hero() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], [0, 90]);

  return (
    <section
      id="hero"
      ref={ref}
      className="relative w-full min-h-fit md:min-h-[80vh] flex items-center overflow-hidden"
      data-testid="hero-section"
    >
      <motion.img
        src="/ocean-growth-hd-2.png"
        alt="ACS Corporate — Ingénierie financière"
        style={{ y: imgY }}
        className="absolute inset-0 w-full h-full object-cover z-0 scale-110"
        data-testid="hero-image"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/80 to-transparent z-10" />
      <div className="relative z-20 w-full max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 py-12 md:py-32">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.1 }}
        >
          <Chapter index="01" label="Ingénierie financière" />
        </motion.div>
        <h1
          data-testid="hero-title"
          className="mt-8 max-w-3xl font-sans font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight"
        >
          {LINES.map((line, i) => (
            <span key={i} className="block overflow-hidden pb-1">
              <motion.span
                className="block"
                initial={{ y: "115%" }}
                animate={{ y: 0 }}
                transition={{ duration: 1, delay: 0.25 + i * 0.14, ease: EASE }}
              >
                {line}
              </motion.span>
            </span>
          ))}
        </h1>
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.75, ease: EASE }}
          className="mt-8 max-w-xl text-base sm:text-lg text-white leading-relaxed"
          data-testid="hero-subtitle"
        >
          Accélérez le traitement de vos dossiers complexes. Nous allions la précision du
          sur-mesure à la rapidité d'un audit flash. Des analyses stratégiques et chiffrées
          destinées aux avocats et mandataires judiciaires, aux gérants de PME et directions
          financières.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.9, ease: EASE }}
          className="mt-10 flex flex-wrap items-center gap-6"
        >
          <a
            href="#contact"
            onClick={scrollToHash("#contact")}
            data-testid="hero-cta-memo-flash"
            className="group inline-flex items-center gap-2 bg-white text-slate-900 px-8 py-4 rounded-full font-medium hover:bg-slate-200 transition-colors duration-300"
          >
            Obtenir mon 1er Mémo Flash (Offert)
            <ArrowDownRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:translate-y-0.5" />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
